import PropTypes from 'prop-types';

const pinStyle = {
  cursor: 'pointer',
  pointerEvents: 'auto',
  filter: 'drop-shadow(0px 2px 5px rgba(0, 0, 0, .2))',
};

const MapPinNormal = ({ fill='#FED844', stroke='#052B52', width=65, height=80, ariaLabel='', onClick }) => {
  return (
    <svg
      //
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 85 100"
      style={{ ...pinStyle }}
      width={width}
      height={height}
      aria-label={ariaLabel}
      onClick={onClick}
    >
      <defs>
        <path
          id="map-pin-normal"
          d="M32.5 40.216c-6.167 0-11.184-5.041-11.184-11.236 0-6.196 5.017-11.236 11.184-11.236 6.167 0 11.184 5.04 11.184 11.236 0 6.195-5.017 11.236-11.184 11.236M32.5 0C14.58 0 0 14.648 0 32.654c0 7.504 5.167 17.661 15.358 30.193 7.36 9.048 14.602 15.969 14.906 16.257A3.234 3.234 0 0 0 32.5 80c.805 0 1.608-.299 2.236-.896.304-.288 7.547-7.21 14.906-16.257C59.833 50.315 65 40.157 65 32.654 65 14.648 50.421 0 32.5 0"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="map-pin-normal-mask" fill="#fff">
          <use xlinkHref="#map-pin-normal" />
        </mask>
        <use fill={fill} xlinkHref="#map-pin-normal" />
        <path
          stroke={stroke}
          strokeWidth="5"
          d="M32.5 40.216c-6.167 0-11.184-5.041-11.184-11.236 0-6.196 5.017-11.236 11.184-11.236 6.167 0 11.184 5.04 11.184 11.236 0 6.195-5.017 11.236-11.184 11.236M32.5 0C14.58 0 0 14.648 0 32.654c0 7.504 5.167 17.661 15.358 30.193 7.36 9.048 14.602 15.969 14.906 16.257A3.234 3.234 0 0 0 32.5 80c.805 0 1.608-.299 2.236-.896.304-.288 7.547-7.21 14.906-16.257C59.833 50.315 65 40.157 65 32.654 65 14.648 50.421 0 32.5 0"
          mask="url(#map-pin-normal-mask)"
        />
      </g>
    </svg>
  );
};

MapPinNormal.propTypes = {
  fill: PropTypes.string,
  stroke: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  ariaLabel: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

export default MapPinNormal;
